




















































































import { Component, Mixins, Vue } from "vue-property-decorator";
import {
  getQueryParamValue,
  URL_PARAM_SERIAL_CODE,
  URL_PARAM_COURSE,
  URL_PARAM_TOKEN,
  URL_PARAM_TYPE,
  URL_PARAM_TRAN_SRC,
} from "@/utils/url";
import {
  postRequest,
  getCourses,
  COURSE_APPLY_STATE,
  CourseGroups,
  Courses,
} from "@/apis";
import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import TextLabel from "@/components/TextLabel.vue";
import Overlay from "@/components/Overlay.vue";
import PopupDialog from "@/components/PopupDialog.vue";
import SettingMixin from "@/mixins/settingMixin";

@Component({
  components: {
    ContainImage,
    ImageButton,
    TextLabel,
    PopupDialog,
    Overlay,
  },
})
export default class RequestDetail extends Mixins(Vue, SettingMixin) {
  courses: Courses | null = null;
  usedCount: number | null = null;
  imageName = "";
  isRequesting = false;

  get courseId(): number {
    return parseInt(String(this.$route.query.course));
  }

  get serialCode(): string {
    return getQueryParamValue(URL_PARAM_SERIAL_CODE);
  }

  get type(): string {
    return this.$route.query[URL_PARAM_TYPE] + "";
  }

  get errorLinepoint(): string {
    return this.config.imageName.requestDetailPage?.errorLinepoint
      ? `./images/campaign/${this.config.imageName.requestDetailPage.errorLinepoint}`
      : "";
  }

  get isActive(): boolean {
    return (
      this.courses !== undefined &&
      this.courses !== null &&
      this.courses?.course_apply_state === COURSE_APPLY_STATE.ApplyOk
    );
  }

  get courseApplyStateText(): string {
    if (
      this.courses?.course_apply_state ===
      COURSE_APPLY_STATE.ApplyNgWonLimitOver
    ) {
      return "こちらのコースには応募できません ";
    } else if (
      this.courses?.course_apply_state ===
      COURSE_APPLY_STATE.ApplyNgCollectionNotEnough
    ) {
      return "シール数が不足しているためこちらのコースには応募できません";
    }
    return "";
  }

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;
    const isWin = await this.checkIsWin();
    if (isWin) return;
    // postActionLog(
    //   this.campaignId,
    //   this.token,
    //   this.serialCode,
    //   this.campaignId,
    //   "apply_course_detail_view"
    // );
    await this.getCourses();
    return;
  }

  async getCourses(): Promise<void> {
    // 応募コース取得
    const res = await getCourses(this.campaignId, this.token).catch((err) => {
      console.log(err);
      // 各種エラー
      this.showErrorDialog(this.responseError(err));
      return;
    });

    if (!res) return;

    let typeId = 0;
    if (this.type === "LINE") typeId = this.courseGroupEnv.line.id;
    if (this.type === "inKind") typeId = this.courseGroupEnv.collab.id;

    const res_course_groups = res.data.course_groups.find(
      (x: CourseGroups) => x.id === typeId
    );

    if (!res_course_groups) return;
    const course = res_course_groups.courses.find(
      (x: Courses) => x.id === this.courseId
    );
    if (!course) return;

    this.courses = course;
    this.usedCount = res.data.owned_count - course.cost;

    if (!this.config.imageName.requestDetailPage) return;
    if (!this.courseImageNameEnv[this.courseId]) return;

    this.imageName = this.courseImageNameEnv[this.courseId].detail ?? "";
    this.$nextTick(function () {
      this.$forceUpdate();
    });
  }

  async requestProduct(): Promise<void> {
    // postActionLog(
    //   this.campaignId,
    //   this.token,
    //   this.serialCode,
    //   this.campaignId,
    //   "apply_course_push"
    // );

    if (!this.courses) return;

    if (this.isRequesting) return;

    this.isRequesting = true;

    // 応募コース取得
    const res = await postRequest(
      this.campaignId,
      this.token,
      this.courses.id
    ).catch((err) => {
      // 各種エラー
      this.showErrorDialog(this.responseError(err));
      return;
    });

    if (!res) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any = res.data;

    this.pushWithTransition(() => {
      this.$router.push({
        name: "Result",
        params: {
          result: result,
        },
        query: {
          [URL_PARAM_TOKEN]: this.token,
          [URL_PARAM_COURSE]: String(this.courseId),
          [URL_PARAM_TRAN_SRC]: this.transitionSrc,
        },
      });
    });

    setTimeout(() => {
      this.isRequesting = false;
    }, 1000);
  }

  getImagePath(val: string): string {
    return `./images/campaign/${val}`;
  }

  onClickToBack(): void {
    this.$router.back();
  }
}
